import axios from 'axios';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';

// NOTE: Don't forget to invoke your service to actually get the observable
// I.E. Bad - actionPayments$.subscribe() | Good - actionPayments$(payload).subscribe()

const returnResponse = ({ data: { data, result, success } }) => ({ data, success, result });
// Takes an endpoint and returns a function (that has a payload) that returns an observable
const returnFnObs = (endpoint) => (payload) =>
  from(axios.post(endpoint, payload)).pipe(map(returnResponse));

// PAYMENT ACTIONS
export const actionPayments$ = returnFnObs('/payments/actionPayments');
export const activatePayment$ = returnFnObs('/payments/activatePayment');
export const activateTaxPayment$ = returnFnObs('/payments/activateTaxPayment');
export const convertAchPaymentToFreeform$ = returnFnObs('/payments/convertAchPaymentToFreeform');
export const copyAchPayment$ = returnFnObs('/payments/copyAchPayment');
export const copyAchPaymentAsTemplate$ = returnFnObs('/payments/copyAchPaymentAsTemplate');
export const createACHPayment$ = returnFnObs('/payments/createACHPayment');
export const deleteACHPaymentTransactionDetails$ = returnFnObs(
  '/payments/deleteACHPaymentTransactionDetails'
);
export const saveACHPaymentTransactionDetails$ = returnFnObs(
  'payments/saveACHPaymentTransactionDetails'
);
export const updatePayment$ = returnFnObs('/payments/updatePayment');
export const updatePaymentDate$ = returnFnObs('/payments/updatePaymentDate');
export const updateStaleDatedPayments$ = returnFnObs('/payments/updateStaleDatedPayments');

export const updateACHPaymentTransactionDetails$ = returnFnObs(
  '/payments/updateACHPaymentTransactionDetails'
);
export const updateAchActiveParticipantTransactionAmount$ = returnFnObs(
  '/payments/updateAchActiveParticipantTransactionAmount'
);
export const updateAchParticipantTransactionAmount$ = returnFnObs(
  '/payments/updateAchParticipantTransactionAmount'
);
export const zeroAllACHPaymentTransactionAmount$ = returnFnObs(
  '/payments/zeroAllACHPaymentTransactionAmounts'
);

export const reverseValidateAction$ = returnFnObs(
  '/payments/achReversal/validatePendingReversals'
);
export const reversePayments$ = returnFnObs('/payments/achReversal/createReversedBatch');
export const modifyReversalDate$ = returnFnObs('/payments/achReversal/modifyReversalDate');
export const validateReversingPayments$ = returnFnObs(
  '/payments/achReversal/validateReversalBatch'
);

// TRANSACTION BULK ACCTIONS
export const actionAchPaymentTemplateTransactions$ = returnFnObs(
  'payments/actionAchPaymentTemplateTransactions'
);
export const actionAchPaymentTransactions$ = returnFnObs('payments/actionAchPaymentTransactions');
export const deleteAchPaymentTransactions$ = returnFnObs('payments/deleteACHPaymentTransactions');
export const deleteAchTransactions$ = returnFnObs('payments/deleteACHTransactions');

// LOADING PAYMENT DATA
export const getACHCompanyForPaymentType$ = returnFnObs('/payments/getAchCompanyForPaymentType');
export const getPaymentTypes$ = returnFnObs('/payments/getPaymentTypes');
export const getSMBPaymentTypes$ = returnFnObs('/payments/getSMBPaymentTypes');
export const getACHPaymentSettings$ = returnFnObs('/payments/getACHPaymentSettings');
// Date settings for existing ach payments - below
export const getAchSettings$ = returnFnObs('/payments/getAchSettings');
export const getContactAchSettings$ = returnFnObs('/payments/contact/getAchSettings');
export const getAllCountries$ = returnFnObs('/payments/getAllCountries');
export const getInternationalACHDestCountries$ = returnFnObs(
  '/payments/getInternationalACHDestCountries'
);
export const getInternationalACHDestCurrencies$ = returnFnObs(
  '/payments/getInternationalACHDestCurrencies'
);
export const getInternationalACHFX$ = returnFnObs('/payments/getInternationalACHFX');
export const retrievePaymentDetails$ = returnFnObs('/payments/retrievePaymentDetails');

// TEMPLATE ACTIONS
export const actionPaymentTemplates$ = returnFnObs('/payments/actionPaymentTemplates');
export const copyPaymentTemplate$ = returnFnObs('/payments/copyPaymentTemplate');
export const deleteACHTransactionDetails$ = returnFnObs('/payments/deleteACHTransactionDetails');
export const initiatePayment$ = returnFnObs('/payments/initiatePayment');
export const saveACHTransactionDetails$ = returnFnObs('/payments/saveACHTransactionDetails');
export const savePaymentTemplate$ = returnFnObs('/payments/savePaymentTemplate');
export const updateACHTransactionDetails$ = returnFnObs('/payments/updateACHTransactionDetails');
export const updatePaymentTemplate$ = returnFnObs('/payments/updatePaymentTemplate');
export const zeroAllACHTransactionsAmount$ = returnFnObs('/payments/zeroAllACHTransactionsAmount');

// LOADING TEMPLATE DATA
export const getAccountTypesForTemplates$ = returnFnObs('/payments/getAccountTypesForTemplates');
export const getAchTemplateSettings$ = returnFnObs('/payments/getAchTemplateSettings');
export const getAllTransactionDetailsForACHBatch$ = returnFnObs(
  '/payments/getAllTransactionDetailsForACHBatch'
);
export const getPaymentTemplateDetails$ = returnFnObs('/payments/getPaymentTemplateDetails');
export const getPaymentTypesForTemplates$ = returnFnObs('/payments/getPaymentTypesForTemplates');

export const isValidTemplateName$ = returnFnObs('/payments/isValidTemplateName');
export const getPaymentTemplateActions$ = returnFnObs('/payments/getPaymentTemplateActions');
